/** Google Ads conversion / tag ID (gtag.js). */
export const GOOGLE_ADS_TAG_ID = 'AW-18026715452'

/** Notify Google Ads of SPA navigations (initial load is configured in index.html). */
export function trackGoogleAdsPageView(pagePath) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  const path = pagePath ?? `${window.location.pathname}${window.location.search}`
  window.gtag('config', GOOGLE_ADS_TAG_ID, { page_path: path })
}
